import type { MutableState } from 'final-form';

export const setFieldTouched = <T = Record<string, any>>(
  [name, touched]: [string, boolean], state: MutableState<T>,
) => {
  const field = state.fields[name];
  if (field) {
    field.touched = !!touched;
  }
};

export const changeFieldValue = <T = Record<string, any>>(
  [name, value]: [string, any], state: MutableState<T>,
) => {
  const field = state.fields[name];
  if (field) {
    field.change(value);
  }
};
